var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57808 3.99972L7.50776 0.507534C7.55687 0.449498 7.51558 0.361328 7.43968 0.361328H6.54906C6.4966 0.361328 6.44638 0.384766 6.41178 0.424944L3.99549 3.30552L1.57919 0.424944C1.54571 0.384766 1.49549 0.361328 1.44191 0.361328H0.551289C0.475396 0.361328 0.434102 0.449498 0.483209 0.507534L3.4129 3.99972L0.483209 7.49191C0.472208 7.50485 0.465151 7.52067 0.462875 7.53749C0.460598 7.55432 0.463198 7.57145 0.470367 7.58684C0.477535 7.60224 0.48897 7.61525 0.503314 7.62434C0.517658 7.63343 0.534309 7.63821 0.551289 7.63811H1.44191C1.49437 7.63811 1.54459 7.61468 1.57919 7.5745L3.99549 4.69392L6.41178 7.5745C6.44526 7.61468 6.49549 7.63811 6.54906 7.63811H7.43968C7.51558 7.63811 7.55687 7.54995 7.50776 7.49191L4.57808 3.99972Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/CloseX.cca4d334.svg";
export { ForwardRef as ReactComponent };